import {
  Button,
  Checkbox,
  Chip,
  IconButton,
  ListItemText,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import DrillxToggle from 'components/DrillxToggle';
import { useIntl } from 'react-intl';

import styles from './AdvanceSearch.module.scss';

export interface wellNameType {
  name?: string | undefined;
  value: unknown;
}

interface Props {
  countries: (string | undefined)[];
  onSelectCountries: (event: React.ChangeEvent<wellNameType>) => void;
  onChangeLiveToggle: () => void;
  onChangeReportingToggle: () => void;
  onClickClearIcon: () => void;
  onClickSelectAllCheckBox: () => void;
  selectedCountries: string[];
  isReportingDataSwitchActive: boolean;
  isLiveDataSwitchActive: boolean;
  isSelectedAllCheckBox: boolean;
}

const AdvanceSearch = ({
  countries,
  selectedCountries,
  onSelectCountries,
  onChangeLiveToggle,
  onChangeReportingToggle,
  onClickClearIcon,
  isReportingDataSwitchActive,
  isLiveDataSwitchActive,
  isSelectedAllCheckBox,
}: Props) => {
  const intl = useIntl();
  const useStyles = makeStyles({
    outlinedInput: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: 0,
      },

      '& .MuiSelect-selectMenu': {
        overflow: 'inherit',
        whiteSpace: 'break-spaces',
        height: '-webkit-fill-available',
      },

      '& .MuiChip-root': {
        marginBottom: 2,
        marginRight: 2,
      },
    },
  });

  const classes = useStyles();

  return (
    <div className={styles.advanceSearchContent}>
      <div className={styles.contriesList}>
        <span className={styles.countryTitle}>Country</span>
        <div className={styles.wellsContainer}>
          <Select
            labelId="countries-list"
            id="countries-list"
            multiple
            value={selectedCountries}
            className={clsx(styles.countriesSelect, classes.outlinedInput)}
            onChange={event => onSelectCountries(event)}
            input={<OutlinedInput id="countries-list" />}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              classes: {
                paper: styles.paper,
              },
              getContentAnchorEl: null,
            }}
            renderValue={(selected: any) => (
              <>
                {selected.map((value: any) => (
                  <Chip key={value} className={styles.chipComponent} label={value} />
                ))}
              </>
            )}
          >
            {countries.map((name, index) => (
              <MenuItem key={name} value={name}>
                {index === 0 ? (
                  <Button className={styles.selectAllButton} variant="text">
                    {isSelectedAllCheckBox
                      ? intl.formatMessage({ id: 'advancedSearch.unSelectAll' })
                      : intl.formatMessage({ id: 'advancedSearch.selectAll' })}
                  </Button>
                ) : (
                  <>
                    <Checkbox
                      checked={selectedCountries.indexOf(name as string) > -1}
                      className={styles.countryCheckBox}
                    />
                    <ListItemText className={styles.listItemText} primary={name} />{' '}
                  </>
                )}
              </MenuItem>
            ))}
          </Select>
          <div className={styles.iconContainer}>
            <IconButton onClick={() => onClickClearIcon()}>
              <CloseIcon className={styles.clearIcon} />{' '}
            </IconButton>
          </div>
        </div>
      </div>
      <div className={styles.liveData}>
        <DrillxToggle
          onChange={() => onChangeLiveToggle()}
          checked={isLiveDataSwitchActive}
          label={intl.formatMessage({ id: 'advancedSearch.live' })}
        />
      </div>
      <div className={styles.reportingData}>
        <DrillxToggle
          onChange={() => onChangeReportingToggle()}
          checked={isReportingDataSwitchActive}
          label={intl.formatMessage({ id: 'advancedSearch.reporting' })}
        />
      </div>
    </div>
  );
};

export default AdvanceSearch;
